import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ParentView from "../../Views/PrarentView/ParentView";
import EventView from "../../Views/Event/EventView";

const EventScreen = (props: any) => {
  const [parentViewCheck, setParentViewCheck] = useState(true);
  const location = useLocation();
  useEffect(() => {
    const pathData = location.pathname;

    if (pathData.includes("nativeViews")) {
      props.setIsMobileView(true);
      setParentViewCheck(false);
    }
  }, [location]);

  return (
    <>
      {parentViewCheck ? (
        <ParentView>
          <EventView parentViewCheck={parentViewCheck} />
        </ParentView>
      ) : (
        <EventView parentViewCheck={parentViewCheck}/>
      )}
    </>
  );
};

export default EventScreen;
